import { Data as ArticleData } from '@root/modules/article/types/article';
import { Source } from '@root/common/types/fragment';

export default function getArticleSources(article: ArticleData) {
  let sources: Source[] = [];

  if (article.sources.items.length) {
    sources = article.sources.items;
  } else if (article.sourcesAsAttribute.length) {
    sources = article.sourcesAsAttribute[0].value;
  }

  return sources;
}
